/* eslint-disable ember/use-ember-data-rfc-395-imports */
import type DS from 'ember-data';
import type { ModelRegistry } from 'ember-data/model';

import V2Adapter from './v2';

export default class extends V2Adapter {
  urlForCreateRecord(...args: Parameters<V2Adapter['urlForCreateRecord']>): string {
    return `${super.urlForCreateRecord(...args)}?include=visit-approval,visit-approval.screener-results,visit-approval.screener-reviews`;
  }

  urlForFindRecord<K extends keyof ModelRegistry>(id: string, modelName: K, snapshot: DS.Snapshot<K>): string {
    let url = super.urlForFindRecord(id, modelName, snapshot);
    const adapterOptions = snapshot?.adapterOptions;

    if (adapterOptions?.['fields']) {
      const queryParams = [];
      const fields = adapterOptions['fields'] as Record<string, string>;

      for (const field in fields) {
        queryParams.push(`fields[${field}]=${fields[field]}`);
      }

      if (queryParams.length > 0) {
        const separator = url.includes('?') ? '&' : '?';
        url += `${separator}${queryParams.join('&')}`;
      }
    }

    return url;
  }
}
